import { render, staticRenderFns } from "./CirculationProfileSchema.vue?vue&type=template&id=05d37275&"
import script from "./CirculationProfileSchema.vue?vue&type=script&lang=js&"
export * from "./CirculationProfileSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports